<script lang="ts">
    import {ignoreUnusedProperties} from 'shared/utils/custom-utils';
    import type {LabeledReference, UUID} from 'typings/portaro.be.types';

    export let value: LabeledReference<UUID>;

    ignoreUnusedProperties(value);
</script>

<span class="empty-component"></span>